/* eslint-disable jsx-a11y/alt-text */
import { useAuth0 } from "@auth0/auth0-react";
import { CircularProgress, IconButton, TableContainer, Tooltip } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { withStyles } from "@material-ui/core/styles";
import Pagination from "@material-ui/lab/Pagination";
import ArchiveIcon from "@mui/icons-material/Archive";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import ForwardToInboxIcon from "@mui/icons-material/ForwardToInbox";
import PrintIcon from "@mui/icons-material/Print";
import PreSchoolService from "Lib/API/PreSchool";
import { ReactComponent as SortIcon } from "assets/icons/SortIcon.svg";
import Action from "components/ActionPopOver";
import { CheckBox } from "components/CheckBox/CheckBox";
import AlertDialog from "components/Dialog";
import MyButton from "components/MyButton";
import SearchComp from "components/Searchcomponent";
import SendLetter from "components/SendLetter/SendLetter";
import SuccessModal from "components/SuccessModal/SuccessModal";
import RightDrawer from "components/drawer";
import Loader from "components/loader/Loader";
import ProgressBar from "components/progressBar/progressbar";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import { setEventName } from "services/api/events";
import { displayProductsHandler, getFormDataHandler } from "utils/formDataHelper";
import * as XLSX from "xlsx";
import { sanitizeRows } from "utils/exportSanitize";
import { setOpenRecipients, setSelectedDeceased } from "./commonSlice";
import Recipients from "./deceasedLetter/Recipients";
import EventDrawer from "./eventComponent/EventDrawer";
import "./index.scss";
import { fontConfig } from "theme/fontConfig";

const TableCellHead = withStyles((theme) => ({
  root: {
    height: "39px",
    padding: "0px 20px",
    borderBottom: "none",
    fontFamily: fontConfig.GeneralTableCellHeadFont.family,
  },
}))(TableCell);

const TableCellBody = withStyles((theme) => ({
  root: {
    height: "65px",
    padding: "0px 20px",
    fontFamily: fontConfig.GeneralTableCellBodyFont.family,
    fontSize: "14px",
    color: "#4f4f4f",
  },
}))(TableCell);

const CurrentEvents = ({
  setOpenDialog,
  archived,
  duplicate,
  setError,
  newClassName,
  setData,
  setDisabled,
  setClassesCount,
  sortCharged,
  handleSort,
  setSorting,
  sorting,
  handleInputChange,
  searchValue,
  toggle,
  tableContainerRef,
  archivedClassPage,
  setArchivedClassPage,
  activeClassPage,
  setActiveClassPage,
  ...props
}) => {
  const [openDialog, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [list, setList] = useState([]);
  const { getAccessTokenSilently } = useAuth0();
  const [selectionModel, setSelectionModel] = useState([]);
  const [data, addData] = useState();
  const history = useHistory();
  const [count, setCount] = useState();
  const [activeClassCount, setActiveClassCount] = useState();
  const [archivedCount, setArchivedCount] = useState();
  const dispatch = useDispatch();
  const [deleteEventId, setDeleteEventId] = useState(null);
  const [duplicateEventId, setDuplicateEventId] = useState(null);
  const [archiveEventId, setArchiveEventId] = useState([]);
  const [archiveStatus, setArchiveStatus] = useState(false);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [drawerData, setDrawerData] = useState({});
  const [check, setCheck] = useState([]);
  const [exportAllTable, setExportAllTable] = useState(false);
  const styleButtons = { color: '#454758', fontSize: '14px', fontWeight: '400' }
  const [csvData, setExportData] = useState([]);
  const [participantExportData, setParticipantExportData] = useState([]);
  const [enableExportingParticipants, setEnableExportingParticipants] = useState(false);
  const [exportType, setExportType] = useState("");
  const [checkAll, setCheckAll] = useState(false)
  const [openLetterModal, setOpenLetterModal] = useState(false);
  const [openSuccessModal, setOpenSuccessModal] = useState(false);
  const [sendLetterLoading, setSendLetterLoading] = useState(false);
  const [exportAllClassesParticipants, setExportAllClassesParticipants] = useState(false);
  const [exportAllLoading, setExportAllLoading] = useState(false);
  const [exportAllClassesParticipantsLoading, setExportAllClassesParticipantsLoading] = useState(false)

  const openRecipients = useSelector(
    (state) => state.CommonStates.openRecipients
  );

  const organization = localStorage.getItem('organization')
    ? JSON.parse(localStorage.getItem('organization'))
    : null;
  const orgKey = organization?.orgkey;

  useEffect(() => {
    const data = {
      class_Ids: selectionModel,
      archived: true,
    };
    //post the data
    if (archived) {
      setOpen(true);
      addData(data);
    }
  }, [archived]);

  const deleteEvent = async (id) => {
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      await PreSchoolService.deleteEvent(token, id);
      toastr.success("Success", "Event Deleted Successfully!");
      setRefresh(!refresh);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      setDeleteEventId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
      setIsDrawerOpen(false);
    }
  };

  const archiveEvent = async () => {
    const data = {
      ids: archiveEventId,
      status: archiveStatus,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      await PreSchoolService.archiveEvent(token, data);
      toastr.success("Success", `Event ${archiveStatus ? "Archived" : "Un-Archived"} Successfully!`);
      setRefresh(!refresh);
      setCheck([]);
      setCheckAll(false);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      setArchiveEventId([]);
      setConfirmDialog(false);
      setConfirmLoading(false);
      setIsDrawerOpen(false);
    }
  };

  const duplicateEvent = async (duplicateEventId) => {
    const payload = {
      eventId: duplicateEventId,
    };
    try {
      setConfirmLoading(true);
      const token = await getAccessTokenSilently();
      await PreSchoolService.duplicateEvent(token, payload);
      toastr.success("Success", "Event Duplicated Successfully!");
      setRefresh(!refresh);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      setDuplicateEventId(null);
      setConfirmDialog(false);
      setConfirmLoading(false);
    }
  };

  // This function called when Archived toggle button is clicked and when the page is changed in pagaination (this function will not used in useEffect)
  const getArchivedEvents = async (page) => {
    try {
      enableLoading(true);
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.getArchivedEvents(
        token,
        page || archivedClassPage + 1,
        30,
        sorting
      );
      setList(result?.payload?.data);
      setCount(result?.payload?.pagination?.count);
      setArchivedCount(result?.payload?.pagination?.count);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      enableLoading(false);
    }
  };
  useEffect(() => {
    if (selectionModel.length > 1) {
      setError("You Can Duplicate 1 Class only!");
      setDisabled(true);
    } else if (selectionModel.length === 1) {
      const data = {
        selectedClassId: selectionModel[0],
        newClassName: newClassName,
      };
      setOpenDialog(true);
      setData(data);
    }
  }, [duplicate, newClassName]);

  useEffect(() => {
    if (selectionModel.length > 1) setDisabled(true);
    else setDisabled(false);
  }, [selectionModel]);

  const onCheckboxAllChange = (e) => {
    setCheckAll(e.target.checked)
    if (!e.target.checked) {
      setCheck([]);
    }
  };

  const enableLoading = (value) => {
    setLoading(value);
  };

  async function getEventList() {
    enableLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const result = await PreSchoolService.getEventList(
        token,
        activeClassPage + 1,
        30,
        sorting
      );
      setList(result?.payload?.data);
      setCount(result?.payload?.pagination?.count);
      setActiveClassCount(result?.payload?.pagination?.count);
    } catch (error) {
      toastr.error("Error", error?.data?.message || "Something went wrong!");
    } finally {
      enableLoading(false);
    }
  }
  useEffect(() => {
    if (toggle) {
      getEventList();
    } else {
      getArchivedEvents();
    }
  }, [activeClassPage, refresh, sorting, toggle]);

  const onClickEvent = (data) => {
    if (data.field !== "number_of_participants")
      history.push(`/class-details/${data.id}`);
    else history.push(`/class-participants/${data.id}`);
  };


  const onCheckboxChange = (e, row) => {
    const { checked } = e.target;
    if (checkAll) return;
    if (!checked) {
      setCheckAll(false)
      setCheck((prev) => {
        const checkClone = prev.filter((item) => item._id !== row._id);
        return [...checkClone];
      });
      return;
    } else if (check.length === csvData.length) {
      setCheckAll(true)
    }
    setCheck((prev) => [
      ...prev,
      row

    ]);
  };
  const columns_for_header = [
    {
      id: "eventName",
      displayName: "Event Name",
      headerName: "Event Name",
      field: "eventName",
      flex: 1,
    },
    {
      id: "date",
      displayName: "Date",
      headerName: "Event Date",
      field: "date",
      flex: 1,
    },
    {
      id: "eventStartDate",
      displayName: "Registration Start Date",
      headerName: "Registration Start Date",
      field: "eventStartDate",
      flex: 1,
    },
    {
      id: "eventEndDate",
      displayName: "Registration End Date",
      headerName: "Registration End Date",
      field: "eventEndDate",
      flex: 1,
    },
    {
      id: "eventType",
      displayName: "Event Type",
      headerName: "Event Type",
      field: "eventType",
      flex: 1,
    },
    {
      id: "allowNonMembers",
      displayName: "Non Member",
      headerName: "Non Member",
      field: "allowNonMembers",
      flex: 1,
    },
    {
      id: "total",
      displayName: "Response",
      headerName: "Response",
      field: "total",
      flex: 1,
    },
    {
      id: "total_cost",
      displayName: "Total Paid",
      headerName: "Total Paid",
      field: "total_cost",
      flex: 1,
    },
  ];
  const getExportFileName = () => {
    if (exportAllClassesParticipants) {
      return "Participants.xlsx"
    } else if (exportAllTable) {
      return `${drawerData?.eventName}.xlsx`
    } else if (check?.length === 1) {
      return `${check[0]?.eventName}.xlsx`
    } else {
      return "Events.xlsx"
    }
  }

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: getExportFileName(),
  });
  useEffect(() => {
    if (exportType == "print") {
      handlePrint();
    }
    setExportType("");
  }, [exportType]);
  const compareDate = (date) => {
    const today = new Date();
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    const date1 = new Date(date);
    if (date1.toDateString() === today.toDateString()) {
      return <span style={{ color: "#2555EF" }}>Today</span>;
    } else if (date1.toDateString() === tomorrow.toDateString()) {
      return <span style={{ color: "#2555EF" }}>Tomorrow</span>;
    } else {
      return formatDate({ date });
    }
  };
  const handleArchiveButton = () => {
    const dataList = checkAll ? csvData : check
    const ides = dataList?.map(item => {
      return item._id
    })
    setArchiveEventId(ides);
    setArchiveStatus(true);
    setConfirmDialog(true);
  }

  const getExportParticipantsData = async (value) => {
    if (exportAllClassesParticipants) {
      setExportAllClassesParticipantsLoading(true)
    } else {
      setExportAllLoading(true)
    }
    const token = await getAccessTokenSilently();
    const body = {
      eventId: !exportAllClassesParticipants ? drawerData?._id : undefined,
      eventIds: exportAllClassesParticipants ? checkAll ? [] : check.map(item => item._id) : undefined,
      participantsIds: []
    }
    PreSchoolService.exportParticipant(token, body)
      .then((res) => {
        setParticipantExportData(res?.payload?.data);
        setEnableExportingParticipants(true)
      })
      .catch((err) => {
        setEnableExportingParticipants(false)
        toastr.error("Error", err?.data?.message || "Something went wrong!");
      })
      .finally(() => {
        if (exportAllClassesParticipants) {
          setExportAllClassesParticipantsLoading(false)
        } else {
          setExportAllLoading(false)
        }
      });
  };



  const formatMultiEventDates = (multiEventsDates) =>
    (multiEventsDates || [])
      .map(d => d.eventDate ? formatDate({ date: d.eventDate, formatType: 'defaultWithTimeUTC' }) : '')
      .filter(Boolean)
      .join(', ');

  const getEventTypeDisplay = (eventDetails, isMulti, isDisplayOnly) => {
    const parts = [eventDetails?.eventType];
    if (isDisplayOnly) parts.push('Display Only');
    if (isMulti) parts.push('Multi Events');
    return parts.filter(Boolean).join(' & ') || '';
  };

  const getMultiDateParticipantFields = (item, eventDates, isGrouped) => {
    if (!eventDates?.length) return {};
    return eventDates.reduce((acc, dateEntry) => {
      const dateStr = dateEntry.eventDate
        ? formatDate({ date: dateEntry.eventDate, formatType: 'defaultWithTimeUTC' })
        : '';
      const label = [dateEntry.label, dateStr].filter(Boolean).join(' - ');
      const participantDate = item?.eventsDates?.find(d => d.name === dateEntry.name || d.label === dateEntry.label);
      acc[`Registered to ${label}`] = isGrouped ? 'Yes' : (participantDate ? 'Yes' : 'No');
      acc[`Attended to ${label}`] = participantDate?.attended ? 'Yes' : 'No';
      return acc;
    }, {});
  };

  const excelSheet = () => {
    const arr = [];
    const dataExport = checkAll ? csvData : check
    if (exportAllTable || exportAllClassesParticipants) {
      participantExportData.map((item) => {
        const eventDates = exportAllClassesParticipants
          ? item?.event?.multiEventsDates || []
          : drawerData?.multiEventsDates || [];
        const isMulti = exportAllClassesParticipants
          ? !!item?.event?.multiEvents
          : !!drawerData?.multiEvents;
        const isGrouped = exportAllClassesParticipants
          ? item?.event?.multiEventsType === 'grouped'
          : drawerData?.multiEventsType === 'grouped';
        const data = {
          ["#"]: item?.groupId?.toString(),
          ...(exportAllClassesParticipants ? {
            ["Event Name"]: item?.event?.eventName,
          } : {}),
          ["First Name"]: item?.firstName,
          ["Last Name"]: item?.lastName,
          ["Phone Number"]: item?.phone || "-",
          ["Payment Status"]: item?.registrationStatus,
          ["Total Paid"]: `${numberFormat({ number: item?.payment?.register?.totalPaid, decimal: 2, style: 'currency' })}`,
          ...getFormDataHandler(item?.event?.form?.task_data, item?.formData),
          ["Ticket Type"]: item?.ticket?.title || "",
          ...displayProductsHandler(item?.products),
          ...(isMulti ? getMultiDateParticipantFields(item, eventDates, isGrouped) : {}),
        };
        arr.push(data);
      });
    } else if (isDrawerOpen && !exportAllTable) {
      const isMulti = !!drawerData?.multiEvents;
      const data = {
        ["Event Name"]: drawerData?.eventName,
        ["Event Date"]: isMulti
          ? formatMultiEventDates(drawerData?.multiEventsDates)
          : formatDate({ date: drawerData?.date, formatType: "defaultWithTimeUTC" }),
        ["Registration Start Date"]: formatDate({ date: drawerData?.eventStartDate, formatType: "defaultWithTimeUTC" }),
        ["Registration End Date"]: drawerData?.eventEndDate ? formatDate({ date: drawerData?.eventEndDate, formatType: "defaultWithTimeUTC" }) : "",
        ["Event Type"]: getEventTypeDisplay(drawerData?.eventDetails, isMulti, drawerData?.displayOnly),
        ["Non Member"]: drawerData?.allowNonMembers,
        ["Response"]: numberFormat({ number: drawerData?.participantsDetails?.total, decimal: 2 }),
        ["Total Paid"]: numberFormat({ number: drawerData?.eventPricing?.total_cost, decimal: 2, style: 'currency' }),
      };
      arr.push(data);
    }
    else if (checkAll || check?.length > 0) {
      dataExport.map((item) => {
        const isMulti = !!item?.multiEvents;
        const data = {
          ["Event Name"]: item?.eventName,
          ["Event Date"]: isMulti
            ? formatMultiEventDates(item?.multiEventsDates)
            : formatDate({ date: item?.date, formatType: "defaultWithTimeUTC" }),
          ["Registration Start Date"]: formatDate({ date: item?.eventStartDate, formatType: "defaultWithTimeUTC" }),
          ["Registration End Date"]: item?.eventEndDate ? formatDate({ date: item?.eventEndDate, formatType: "defaultWithTimeUTC" }) : "",
          ["Event Type"]: getEventTypeDisplay(item?.eventDetails, isMulti, item?.displayOnly),
          ["Non Member"]: item?.allowNonMembers,
          ["Response"]: numberFormat({ number: item?.participantsDetails?.total, decimal: 2 }),
          ["Total Paid"]: numberFormat({ number: item?.eventPricing?.total_cost, decimal: 2, style: 'currency' }),
        };
        arr.push(data);
      });
    }
    return arr;
  };

  const generateExcel = () => {
    let res = excelSheet()
    const worksheet = XLSX.utils.json_to_sheet(sanitizeRows(res));
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      getExportFileName()
    );
    setExportAllTable(false)
  };



  const downloadExcel = () => {
    generateExcel();
  };
  useEffect(() => {
    if (exportAllClassesParticipantsLoading || exportAllLoading) return
    if (!exportAllTable && !exportAllClassesParticipants) return
    if (exportAllTable && drawerData?.participantsDetails?.total === 0) {
      toastr.info("validation", "No participants found")
      return;
    }
    getExportParticipantsData()
  }, [exportAllTable, exportAllClassesParticipants])
  useEffect(() => {
    if (!enableExportingParticipants) return
    downloadExcel()
    setEnableExportingParticipants(false)
  }, [enableExportingParticipants]);

  let customCsvData = []
  let myData =
    csvData?.length !== 0
    && csvData?.map((item) => {
      // return item?.map((li) => {
      const data = {
        eventName: item?.eventName,
        date: formatDate({ date: item?.date, formatType: "defaultWithTimeUTC" }),
        eventStartDate: formatDate({ date: item?.eventStartDate, formatType: "defaultWithUTC" }),
        eventEndDate: formatDate({ date: item?.eventEndDate, formatType: "defaultWithUTC" }),
        eventType: item?.eventDetails?.eventType,
        allowNonMembers: item?.allowNonMembers,
        total: numberFormat({ number: item?.participantsDetails?.total, decimal: 2 }),
        total_cost: numberFormat({ number: item?.eventPricing?.total_cost, decimal: 2, style: 'currency' }),
      };
      customCsvData.push(data);
      // });
    })

  const getExportData = async (value) => {
    const token = await getAccessTokenSilently();
    const ides = checkAll ? [] : check.map(item => {
      return item._id
    });
    const body = { eventsIds: ides }
    PreSchoolService.exportEvent(token, body)
      .then((res) => {
        setExportData(res?.payload?.data);
        setExportType(value);
      })
      .catch((err) => { });
  };
  useEffect(() => {
    getExportData();
  }, [checkAll]);

  const calculateParticipantsPercentage = (row) => {
    const totalParticipants = row?.participantsDetails?.total;
    const maximumParticipants = row?.eventDetails?.maximumCapacity
    const percentage = (totalParticipants / maximumParticipants) * 100;
    return percentage >= 0 ? Math.round(percentage) : 0;
  };

  const openDrawer = (row) => {
    if (row?.displayOnly) return;
    setDrawerData(row);
    setIsDrawerOpen(true);
  };



  const handleSendLetter = async (templateData) => {
    setSendLetterLoading(true);
    const token = await getAccessTokenSilently();
    const bodyData = {
      eventsIds: checkAll ? [] : check.map((item) => item._id),
      all: checkAll ? true : false,
      ...templateData
    }

    PreSchoolService.sendEventParticipantLetter(token, bodyData)
      .then((response) => {
        setOpenSuccessModal(true);
      })
      .catch((err) => {
        toastr.error("Error", err?.data?.message || "Something went wrong!");
      }).finally(() => {
        setSendLetterLoading(false);
        setOpenLetterModal(false);
      });
  };

  const calculateTotalParticipants = () => {
    let total = 0;
    check.forEach((item) => {
      total += item?.participantsDetails?.total;
    });
    return total;
  }

  const mainUrl = window.location.origin;
  const getLink = (id) => {
    const checkDomain =
      mainUrl === 'https://admin.eztmpl.dev' ||
        mainUrl === 'http://localhost:3000'
        ? `https://shalom.eztmpl.dev/events/${id}`
        : mainUrl === 'https://admin.eztmpl.com'
          ? `https://demo.eztmpl.com/events/${id}`
          : mainUrl === 'https://admin.easyshul.com'
            ? `https://${orgKey}.easyshul.com/events/${id}`
            : mainUrl === 'https://admin-green.easyshul.com' ? `https://localhost.member-green.easyshul.com/events/${id}` : null;
    return checkDomain
  }



  const previewEvent = (id) => {
    const link = getLink(id);
    window.open(link, '_blank');
  };


  return (
    <div
      className="w-100 school_class_list"
    >
      <div className={"family-table-container"}>
        <div className="current-class-table-container">
          <div className="header mt-5">
            <div
              style={{
                display: "flex",
                padding: "20px 0px 10px 2px",
                alignItems: "center",
                marginBottom: "18px",
              }}
              className="header__options"
            >
              <span className="finance-filter-serach-bar ml-5">
                <SearchComp
                  value={searchValue}
                  setSearchText={handleInputChange}
                  placeholder="Search"
                  style={{ width: "20.5rem", backgroundColor: "#fff" }}
                />
              </span>
            </div>
            {(checkAll || check?.length > 0) && toggle && (
              <div className="new-class d-flex align-items-center">
                <MyButton
                  type="secondary"
                  content={
                    <div className="">
                      <ArchiveIcon style={{ height: "20px" }} />
                      <a
                        style={styleButtons}
                      >
                        Archive
                      </a>
                    </div>
                  }
                  style={{
                    background: "#F4F6F9",
                    color: "#2555EF",
                    border: "none",
                    marginRight: "1rem",
                  }}
                  onClick={handleArchiveButton}
                />
                <MyButton
                  type="secondary"
                  content={
                    <div
                      className="d-flex align-items-center justify-content-center"
                    >
                      {exportAllLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <>
                          <FileDownloadIcon style={{ height: "20px" }} />
                          <a
                            style={styleButtons}
                          >
                            Export Events
                          </a>
                        </>
                      )}
                    </div>
                  }
                  style={{
                    background: "#F4F6F9",
                    color: "#2555EF",
                    border: "none",
                    marginRight: "1rem",
                    minWidth: '137px'
                  }}
                  onClick={downloadExcel}
                  disabled={exportAllLoading}
                />
                <MyButton
                  type="secondary"
                  content={
                    <div className="d-flex align-items-center justify-content-center">
                      {exportAllClassesParticipantsLoading ? (
                        <CircularProgress size={20} />
                      ) : (
                        <>
                          <FileDownloadIcon style={{ height: '20px' }} />
                          <a
                            style={styleButtons}
                          >
                            Export Participants
                          </a>
                        </>
                      )}
                    </div>
                  }
                  style={{
                    background: '#F4F6F9',
                    color: '#2555EF',
                    border: 'none',
                    marginRight: '1rem',
                    minWidth: '137px'
                  }}
                  onClick={() => {
                    const dataList = checkAll ? list : check;
                    if (dataList.some(item => item?.displayOnly)) {
                      toastr.info("Info", "Display Only events do not support participant list export");
                      return;
                    }
                    setExportAllClassesParticipants((prev) => !prev);
                  }}
                  disabled={exportAllClassesParticipantsLoading}
                />
                <MyButton
                  type="secondary"
                  onClick={() => getExportData("print")}
                  content={
                    <div className="">
                      <PrintIcon style={{ height: "20px" }} />
                      <a
                        style={styleButtons}
                      >
                        Print
                      </a>
                    </div>
                  }
                  style={{
                    background: "#F4F6F9",
                    color: "#2555EF",
                    border: "none",
                    marginRight: "1rem",
                  }}
                />
                <span className="button-line"
                  style={{
                    height: 20,
                  }}
                />
                <MyButton
                  onClick={() => setOpenLetterModal(true)}
                  type="secondary"
                  content={
                    <div className="" >
                      <ForwardToInboxIcon style={{ height: "20px" }} />
                      Send Letter: {checkAll ? count : check.length}
                    </div>
                  }
                  style={{
                    background: "#D3DDFC",
                    color: "#2555EF",
                    border: "none",
                    marginRight: "1rem",
                    padding: "0px 25px",
                  }}
                />
              </div>
            )}
          </div>
          <div style={{ paddingLeft: "17px", paddingRight: "17px" }} ref={tableContainerRef}>
            <TableContainer className="scroll-table">
              <Table aria-label="collapsible table">
                <TableHead className="charges-table sticky-table-header">
                  <TableRow >
                    <TableCellHead className="main-width-class" >
                      {toggle &&
                        <CheckBox
                          onChange={(e) => {
                            if (!list?.length) return;
                            onCheckboxAllChange(e);
                          }}
                          text={""}
                          style={{ paddingTop: 8 }}
                          checked={checkAll}
                          isDisabled={!list?.length}
                        />
                      }
                    </TableCellHead>

                    <TableCellHead className="class__header__cell className_head">
                      <div>
                        EVENT NAME
                        <IconButton onClick={() => handleSort('name')}>
                          <SortIcon />
                        </IconButton>
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell year__head"
                    >
                      <div>
                        EVENT DATE
                        <IconButton onClick={() => handleSort('date')}>
                          <SortIcon />
                        </IconButton>
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell registration__head"
                    >
                      <div>
                        REGISTRATION PERIOD
                        <IconButton onClick={() => handleSort('registration')}>
                          <SortIcon />
                        </IconButton>
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell ageRane__head"
                    >
                      <div>
                        EVENT TYPE
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell"
                    >
                      <div>
                        MULTIDATE EVENT
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell nonMember__head"
                    >
                      <div>
                        NON MEMBER
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell participants__head"
                    >
                      <div>
                        RESPONSE
                      </div>
                    </TableCellHead>
                    <TableCellHead
                      align="left"
                      className="class__header__cell total__cost"
                    >
                      <div>
                        TOTAL PAID
                      </div>
                    </TableCellHead>

                    <TableCellHead
                      align="left"
                      className="class__header__cell sticky-header-column"
                    />
                  </TableRow>
                </TableHead>
                <TableBody
                  style={{
                    backgroundColor: "white",
                  }}
                >
                  {loading ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <div
                          className="user__loader"
                          style={{ height: "320px" }}
                        >
                          <Loader />
                        </div>
                      </TableCell>
                    </TableRow>
                  ) : list?.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={10} align="center">
                        <h6 style={{ height: "320px", marginTop: "100px" }}>
                          No Events Found
                        </h6>
                      </TableCell>
                    </TableRow>
                  ) : (
                    list?.map((row, i) => (
                      <React.Fragment>
                        <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                          <TableCellBody
                            className="main-width-class"
                            align="left"
                          >
                            {toggle && <CheckBox
                              onChange={(e) => onCheckboxChange(e, row)}
                              checked={checkAll ? true : check.some((obj) => obj._id === row?._id)}
                              text={""}
                              isDisabled={checkAll}
                            />}
                          </TableCellBody>
                          <TableCellBody
                            className="status-head main-width-class"
                            component="th"
                            scope="row"
                            onClick={() => {
                              if (row?.displayOnly) return;
                              dispatch(setEventName(row?.eventName));
                              history.push(
                                `/event-participants/details/${row?._id}`
                              );
                            }}
                            style={row?.displayOnly ? { cursor: 'default' } : {}}
                          >
                            <div className="transaction-status">
                              <div style={{ width: 22 }}></div>
                              <div className="pl-0">
                                <div
                                  className={row?.displayOnly ? "" : "school-table-class-name"}
                                  style={row?.displayOnly ? { fontWeight: 'bold', textTransform: 'capitalize', color: '#888' } : {}}
                                >
                                  {row?.eventName}
                                </div>
                              </div>
                            </div>
                          </TableCellBody>
                          <TableCellBody
                            className="main-width-class"
                            align="left"
                            onClick={() => openDrawer(row)}
                          >
                            <div className="table-row">
                              {row?.multiEvents && row?.multiEventsDates?.length > 0 ? (() => {
                                const dates = row.multiEventsDates.map(d =>
                                  d.eventDate ? formatDate({ date: d.eventDate, formatType: 'defaultWithTimeUTC' }) : ''
                                ).filter(Boolean);
                                const visible = dates.slice(0, 1);
                                const remaining = dates.slice(1);
                                return (
                                  <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                    {visible.map((d, i) => (
                                      <p key={i} className="school-table-year" style={{ margin: 0 }}>{d}</p>
                                    ))}
                                    {remaining.length > 0 && (
                                      <Tooltip
                                        title={
                                          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                                            {remaining.map((d, i) => <span key={i}>{d}</span>)}
                                          </div>
                                        }
                                        placement="bottom-start"
                                      >
                                        <span style={{ fontSize: 12, color: '#2555EF', cursor: 'pointer', fontFamily: fontConfig.EventsCurrentEventsTextFont.family }}>
                                          +{remaining.length} more
                                        </span>
                                      </Tooltip>
                                    )}
                                  </div>
                                );
                              })() : (
                                <p className="school-table-year">{formatDate({ date: row?.date, formatType: 'defaultWithTimeUTC' })}</p>
                              )}
                            </div>
                          </TableCellBody>
                          <TableCellBody
                            className="account-header main-width-class"
                            align="left"
                            onClick={() => openDrawer(row)}
                          >
                            <div className="school-table-registration text-nowrap">
                              {row?.alwaysAvailable
                                ? "Always available"
                                : compareDate(row?.eventStartDate)}-{row?.alwaysAvailable
                                  ? "Always available"
                                  : compareDate(row?.eventEndDate)}
                            </div>
                          </TableCellBody>
                          <TableCellBody
                            className="charged-head main-width-class"
                            align="left"
                            onClick={() => openDrawer(row)}
                          >
                            <div
                              style={{
                                wordBreak: "normal",
                                overflowWrap: "break-word",
                                whiteSpace: "normal",
                              }}
                              className="school-table-dateRange"
                            >
                              {row?.displayOnly
                                ? (row?.eventDetails?.eventType ? `${row?.eventDetails?.eventType} & Display Only` : "Display Only")
                                : row?.eventDetails?.eventType}
                            </div>
                          </TableCellBody>
                          <TableCellBody
                            className="main-width-class"
                            align="left"
                            onClick={() => openDrawer(row)}
                          >
                            {row?.multiEvents === true ? (
                              <CheckCircleIcon
                                color="primary"
                                className="ml-8"
                              />
                            ) : (
                              ""
                            )}
                          </TableCellBody>
                          <TableCellBody
                            style={{
                              wordBreak: "break-all",
                              whiteSpace: "normal",
                            }}
                            className="paid-head main-width-class"
                            align="left"
                            onClick={() => openDrawer(row)}
                          >
                            <div
                              className="transaction-paid table-row"
                              title={row?.allowNonMembers ?? "N/A"}
                            >
                              {row?.allowNonMembers === true ? (
                                <CheckCircleIcon
                                  color="primary"
                                  className="ml-8"
                                />
                              ) : (
                                ""
                              )}
                            </div>{" "}
                          </TableCellBody>
                          <TableCellBody
                            className="ledger-head main-width-class"
                            align="left"
                          >
                            {row?.displayOnly ? "-" : (
                              <ProgressBar
                                bgcolor={
                                  row?.participantsDetails?.total > 100
                                    ? "#FA3372"
                                    : "#2555EF"
                                }
                                progress={calculateParticipantsPercentage(row)}
                                height={6}
                                id={row?._id}
                                class_name={row?.eventName}
                                value={row?.participantsDetails?.total}
                                maxValue={row?.eventDetails?.maximumCapacity}
                                infinite={row?.eventDetails?.infiniteCapacity}
                              />
                            )}
                          </TableCellBody>
                          <TableCellBody
                            className="transaction-head main-width-class"
                            align="left"
                            onClick={() => openDrawer(row)}
                          >
                            {row?.displayOnly ? "-" : numberFormat({ number: +row?.eventPricing?.totalAmount || 0, decimal: 2, style: 'currency' })}
                          </TableCellBody>
                          <TableCellBody
                            className="exp-action-head main-width-class sticky-body-column"
                            align="right"
                          >
                            <div
                              style={{ cursor: "pointer", paddingleft: "0px" }}
                            >
                              <Action
                                action="event"
                                style={{ width: "16px" }}
                                onRegistrationLinkClick={row?.displayOnly ? undefined : () => previewEvent(row?._id)}
                                onEditClick={() =>
                                  history.push(`/edit-event/${row?._id}`)
                                }
                                onDuplicateClick={() => {
                                  setDuplicateEventId(row?._id);
                                  setConfirmDialog(true);
                                }}
                                onArchiveClick={
                                  toggle
                                    ? () => {
                                      setArchiveEventId([row?._id]);
                                      setArchiveStatus(true);
                                      setConfirmDialog(true);
                                    }
                                    : undefined
                                }
                                onActiveClick={
                                  !toggle
                                    ? () => {
                                      setArchiveEventId([row?._id]);
                                      setArchiveStatus(false);
                                      setConfirmDialog(true);
                                    }
                                    : undefined
                                }
                                onClassDeleteClick={() => {
                                  setDeleteEventId(row?._id);
                                  setConfirmDialog(true);
                                }}
                              />
                            </div>
                          </TableCellBody>
                        </TableRow>
                      </React.Fragment>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div className="pagination-custom mt-9">
            <Pagination
              count={Math.ceil(count / 30)}
              color="primary"
              variant="outlined"
              page={
                toggle
                  ? activeClassPage + 1
                  : archivedClassPage + 1
              }
              onChange={(event, value) => {
                if (toggle) {
                  setActiveClassPage(value - 1);
                } else {
                  setArchivedClassPage(value - 1);
                  getArchivedEvents(value);
                }
              }}
            />
          </div>
        </div>
        <div className="d-none">
          <div id="componentRef" ref={componentRef}>
            <table style={{ padding: 10, margin: 10 }}>
              <thead>
                {columns_for_header?.map((column, index) => (
                  <th
                    style={{ border: "1px solid", textAlign: "center" }}
                    key={index}
                  >
                    {column?.headerName}
                  </th>
                ))}
              </thead>
              <tbody>
                {customCsvData?.map((item, index) => {
                  const d = {
                    ["Event Name"]: item?.eventName,
                    ["Date"]: item?.date,
                    ["Registration Start Date"]: item?.eventStartDate,
                    ["Registration End Date"]: item?.eventEndDate,
                    ["Event Type"]: item?.eventType,
                    ["Non Member"]: item?.allowNonMembers ? "true" : "false",
                    ["Response"]: item?.total,
                    ["Total Paid"]: item?.total_cost,
                  };
                  return (
                    <tr key={index}>
                      {Object?.values(d)?.map((objectValue, index) => (
                        <td
                          style={{
                            border: "1px solid",
                            padding: 5,
                          }}
                          key={index}
                        >
                          {objectValue}
                        </td>
                      ))}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
        <AlertDialog
          open={confirmDialog}
          onDecline={() => {
            setDeleteEventId(null);
            setArchiveEventId([]);
            setDuplicateEventId(null);
            setConfirmDialog(false);
          }}
          onAccept={() => {
            if (deleteEventId) {
              deleteEvent(deleteEventId);
            }
            if (archiveEventId.length > 0) {
              archiveEvent(archiveEventId);
            }
            if (duplicateEventId) {
              duplicateEvent(duplicateEventId);
            }
          }}
          content={"Are you sure?"}
          description={`Do you want to ${deleteEventId ? "delete" : duplicateEventId ? "duplicate" : toggle ? "archive" : "active"
            } this Event?`}
          disabled={confirmLoading}
        />
        <RightDrawer
          open={isDrawerOpen}
          onClose={() => {
            setIsDrawerOpen(false);
          }}
        >
          <EventDrawer
            drawerData={drawerData}
            setIsDrawerOpen={setIsDrawerOpen}
            setConfirmDialog={setConfirmDialog}
            setArchiveStatus={setArchiveStatus}
            setDeleteClassId={setDeleteEventId}
            setArchiveClassId={setArchiveEventId}
            toggle={toggle}
            onExport={downloadExcel}
            setExportAllTable={setExportAllTable}
            exportAllTable={exportAllTable}
          />
        </RightDrawer>

        <Dialog
          open={openLetterModal}
          onClose={() => {
            setOpenLetterModal(false);
          }}
          PaperProps={{
            style: {
              width: "888px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
          fullWidth
          maxWidth={"md"}
        >
          <SendLetter
            closeModal={() => {
              setOpenLetterModal(false);
            }}
            isMultiple={true}
            handleSendLetter={handleSendLetter}
            sendLetterLoading={sendLetterLoading}
            type="event"
          />
        </Dialog>

        <Dialog
          open={openRecipients}
          onClose={() => {
            dispatch(setOpenRecipients(false));
            dispatch(setSelectedDeceased([]));
            setCheck([]);
          }}
          PaperProps={{
            style: {
              width: "574px",
              height: "637px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
        >
          <Recipients />
        </Dialog>
        <Dialog
          open={openSuccessModal}
          onClose={() => {
            setOpenSuccessModal(false);
          }}
          PaperProps={{
            style: {
              width: "800px",
              height: "400px",
              overflowX: "hidden",
              borderRadius: "22px",
            },
          }}
        >
          <SuccessModal
            title="Successfully Sent"
            description={`The total number of recipients is ${calculateTotalParticipants()}`}
            btnText="Done"
            btnAction={() => {
              setOpenSuccessModal(false);
            }}
            closeModal={() => {
              setOpenSuccessModal(false);
            }}
          />
        </Dialog>
      </div>
    </div>
  );
};

export default CurrentEvents;
